import { BarChart as AntdBarChart } from "@empglabs/backoffice-ui-kit"

const BarChart = props => {
  return <AntdBarChart {...props} />
}

export default BarChart
